import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Section scroll reveal
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal (for hero headline)
export const MaskedLines = ({ lines, className = "", lineClassName = "", start = false, stagger = 0.12, delay = 0.15 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={start ? { y: "0%" } : {}}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Small eyebrow label
export const Eyebrow = ({ children, className = "" }) => (
  <span className={`font-serifluxe uppercase text-xs tracking-mystic text-gold ${className}`}>
    {children}
  </span>
);

// Ornamental gold divider
export const Divider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3 text-gold/70 ${className}`}>
    <span className="h-px w-16 bg-gradient-to-r from-transparent to-gold/50" />
    <span className="text-sm">✶</span>
    <span className="h-px w-16 bg-gradient-to-l from-transparent to-gold/50" />
  </div>
);
